export class ImportProMappedHeadersProfile {
    id: number = 0;
    filePath: string = '';
    createdById: number = 0;
}
